/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type or paste text…`)
};

const es_tb_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe o pega texto…`)
};

const de_tb_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text eingeben oder einfügen…`)
};

const nl_tb_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type of plak tekst…`)
};

const fr_tb_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapez ou collez du texte…`)
};

const it_tb_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digita o incolla del testo…`)
};

const pt_br2_tb_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite ou cole texto…`)
};

const pt_tb_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva ou cole texto…`)
};

const ja_tb_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを入力するか貼り付けてください…`)
};

const zh_tb_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入或粘贴文本…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_placeholder_encode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_placeholder_encode(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_placeholder_encode", locale)
	if (locale === "en") return en_tb_placeholder_encode(inputs)
	if (locale === "es") return es_tb_placeholder_encode(inputs)
	if (locale === "de") return de_tb_placeholder_encode(inputs)
	if (locale === "nl") return nl_tb_placeholder_encode(inputs)
	if (locale === "fr") return fr_tb_placeholder_encode(inputs)
	if (locale === "it") return it_tb_placeholder_encode(inputs)
	if (locale === "pt-BR") return pt_br2_tb_placeholder_encode(inputs)
	if (locale === "pt") return pt_tb_placeholder_encode(inputs)
	if (locale === "ja") return ja_tb_placeholder_encode(inputs)
	return zh_tb_placeholder_encode(inputs)
};